import { notification } from "antd";
import { useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  useActionUploadAttachmentsMutation,
  useActionValidateOrRefuseMutation,
} from "../../../features/api/apiSlice";
import { FormActionValidatePostValues } from "../../../types/actions";
import { getErrorMessage } from "../../../utils/errors/errors";
import { FormActionValidateSchema } from "./FormActionValidate";

export default function useSubmitValidate({
  id: actionId,
  onSuccess,
}: {
  id: number;
  onSuccess: () => void;
}) {
  const navigate = useNavigate();

  const [validateOrRefuse, { isLoading: isValidating }] =
    useActionValidateOrRefuseMutation();

  const [postAttachments, { isLoading: isPostingAttachments }] =
    useActionUploadAttachmentsMutation();

  const onSubmit: SubmitHandler<FormActionValidateSchema> = useCallback(
    async (values) => {
      try {
        const formattedValues: FormActionValidatePostValues & {
          validateOrRefuse: "validate" | "refused";
        } = {
          ...values,
          actionId,
          attachedFiles: undefined, // Files are uploaded spearatlly (see below)
        };
        console.log("values", values);
        console.log("Formatted Values", formattedValues);

        // 1) "Ask validation" request
        const payload = await validateOrRefuse(formattedValues).unwrap();
        console.log("Response validateOrRefuse", payload);

        // Show success notification
        notification.success({
          message: `L'action a bien Ã©tÃ© ${formattedValues.validateOrRefuse === "validate" ? "validÃ©e" : "refusÃ©e"}.`,
        });

        // 2) Upload attachments (linked to actions)
        const files: undefined | File[] = values?.attachedFiles;

        if (files?.length) {
          const responseUpload = await postAttachments({
            actionId,
            files,
          }).unwrap();
          console.log("Response Upload", responseUpload);
          // Show success notification
          notification.success({
            message: "PiÃ¨ces jointes ajoutÃ©es",
          });
        }

        onSuccess();
      } catch (error) {
        console.error("Error validateOrRefuse", error);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [actionId, onSuccess, postAttachments, validateOrRefuse],
  );

  return {
    onSubmit,
    isLoading: isValidating || isPostingAttachments,
  };
}
